import $ from 'jquery';

import { SELECTORS, IS_HIDDEN, IS_SHOWN, FILTER_OPEN } from './constants';
import {
  decodeFields,
  transformInputToJson,
  trackFilterEvent,
  removeUnnecessaryFields,
  trackFilterEventViaField,
} from './helpers.js';

function initializeFormEvents($form, $filtersWrapper, $calculator, $table) {
  const $body = $('body');
  let selectedFields = [];
  let selectedFieldsTemp = [];
  const $tbody = $table.find('tbody');
  const itemsTotal = $tbody.find('tr').length;
  registerFormEventListeners();
  hideOnMobile();

  function registerFormEventListeners() {
    $body.on('click', SELECTORS.RESET, resetFilters);
    $form.on('submit', handleSubmit);
    $filtersWrapper.on('click', SELECTORS.TOGGLE, toggleFilters);
    $table.on('click', SELECTORS.EDIT_FORM, editFilterForm);
    $form.on('filter-form:change', (event, data) => handleFormChange(data));
    $form.find('[type="radio"]').on('change', handleRadioInput);
    $form.on('click', SELECTORS.CANCEL, cancelFilters);
    $form.on('click', SELECTORS.APPLY, applyFilters);
  }

  function show($element) {
    $element.addClass(IS_SHOWN).removeClass(IS_HIDDEN);
    $('body').addClass(FILTER_OPEN);
    $element.attr('aria-expanded', true);
  }

  function hide($element) {
    $element.removeClass(IS_SHOWN).addClass(IS_HIDDEN);
    $('body').removeClass(FILTER_OPEN);
    $element.attr('aria-expanded', false);
  }

  function setTableHeaderStyle() {
    const $reversedDesignTable = $table.closest(`.${SELECTORS.REVERSED_COMPARISON_CALCULATOR}`);
    if ($reversedDesignTable.length) {
      $reversedDesignTable.toggleClass(SELECTORS.HIDDEN_FILTER_FORM);
    }
  }

  function setFilterForm($element) {
    if ($element.hasClass(IS_SHOWN)) {
      hide($element);
    } else {
      selectedFields = $element.serializeArray();
      show($element);
    }
    setTableHeaderStyle();
  }

  function resetFilters() {
    trackFilterEvent('Reset Filters', 'Clicked reset filters');
    $form.trigger('slider:reset');
    if ($form[0]) {
      $form[0].reset();
    }
    $form.trigger('checkbox:reset');
    $form.submit();
  }

  function toggleFilters(e) {
    e.preventDefault();
    setFilterForm($form);
    setFilterButtonLabel();
    trackFilterEvent('Toggle Filters', $form.hasClass(IS_SHOWN) ? 'shown' : 'hidden');
  }

  function editFilterForm(e) {
    e.preventDefault();
    setFilterForm($form);
    trackFilterEvent('Mobile', 'Monthly Spend Edit');
  }

  function setFilterButtonLabel() {
    const $button = $(SELECTORS.TOGGLE);
    const isShown = $form.hasClass(IS_SHOWN);

    if (isShown) {
      $button.find('span').text('Hide filters');
    } else {
      $button.find('span').text('Filter results');
    }
  }

  function handleRadioInput(event) {
    trackFilterEventViaField($(event.target));
    $form.submit();
  }

  function handleSubmit(e) {
    e.preventDefault();

    selectedFieldsTemp = $form.find(`:not(${SELECTORS.CALCULATOR_FIELDS})`).serializeArray();
    $form.trigger('filter-form:change', [{
      fields: transformInputToJson(selectedFieldsTemp),
    }]);
  }

  function handleFormChange({ fields }) {
    const { category: categoryId, site, fieldset } = $calculator[0].dataset;
    const url = [
      `${window.location.origin}/wordpress/wp-admin/admin-ajax.php?action=redraw_table_ajax`,
      'template=comparison',
      `site=${site}`,
      `category=${categoryId}`,
      `fieldset=${fieldset}`,
      decodeFields(fields),
    ].join('&');

    filterTable(url, $table, $form);
  }

  function filterTable(url) {
    $table.trigger('onLoading');

    $.get(url)
      .then(onTableBodyFetched)
      .then(displayResults, displayNoResults)
      .always((results) => {
        $table.trigger('onLoaded', results);
        $table.trigger('recalculateTableColumn', [$form, $table]);
      });
  }

  function onTableBodyFetched({ html }) {
    const noResults = $('#noResultsFrequentFlyerTemplate').html();
    const noResultsTemplate = Handlebars.compile(noResults);
    return new Promise((resolve, reject) => {
      if (!html) {
        reject({
          count: 0,
          html: noResultsTemplate(),
        });
      } else {
        const itemsCount = (html.match(/<tr/g) || []).length;
        resolve({
          count: itemsCount,
          html,
        });
      }
    });
  }

  function displayResults(results) {
    const {
      count: currentItemsTotal,
    } = results;

    setButtons({ length: currentItemsTotal }, $form);
    setNumbers(currentItemsTotal, itemsTotal, $form);

    return results;
  }

  function displayNoResults(results) {
    setButtons({ length: 0 }, $form);
    setNumbers(0, itemsTotal, $form);

    return results;
  }

  function setButtons(result) {
    const $applyBtn = $form.find('.js-filters-applyBtn');
    const $noResult = $form.find('.js-filters-noResult');

    if (result.length === 0) {
      $applyBtn.addClass('btn-disabled');
      $noResult.removeClass('hide');
    } else {
      $applyBtn.removeClass('btn-disabled');
      $noResult.addClass('hide');
    }
  }

  function setNumbers(count, total) {
    const message = `<span><strong>${count}</strong> of <strong>${total}</strong></span> cards`;
    $form.find(SELECTORS.RESULT_COUNT).html(message);
  }

  function cancelFilters() {
    trackFilterEvent('Mobile', 'Cancel Filter');
    resetForm(selectedFields).done(() => {
      $table.trigger('onLoading');
      hide($form);
      setFilterButtonLabel();
      $form.submit();
    });
  }

  function applyFilters(e) {
    e.preventDefault();
    const $btn = $(e.currentTarget);

    if ($btn.hasClass('btn-disabled')) {
      e.stopPropagation();
      return;
    }

    selectedFields = selectedFieldsTemp;
    trackFilterEvent('Mobile', 'Apply Filter');
    hide($form);
    setFilterButtonLabel();
  }

  function resetForm(fields) {
    const deferred = $.Deferred();

    if (fields.length) {
      fields.map((item) => {
        if (item.name === SELECTORS.SLIDER_FIELD) {
          $form.trigger('slider:setValue', [item.value]);
        } else {
          const $field = $form.find(`[name='${item.name}']`);
          const totalOfFields = $field.length;
          if (totalOfFields) {
            $field.each((fieldCount, input) => {
              if (input.type === 'checkbox') {
                $(input).prop('checked', input.value === item.value);
                if (fieldCount === (totalOfFields - 1)) {
                  $form.trigger('checkbox:updateLabel', [$(input).closest('.luna-dropdown__menu')]);
                }
              }

              if (input.type === 'text') {
                $(input).val(item.value);
              }
            });
          }
        }

        return item;
      });
    }

    deferred.resolve();

    return deferred;
  }

  function isMobile() {
    return window.innerWidth <= 601;
  }

  function hideOnMobile() {
    if (isMobile()) {
      hide($form);
      setFilterButtonLabel();
      removeUnnecessaryFields('.luna-form__field.hide-mobile');
    } else {
      removeUnnecessaryFields('.luna-form__field.hide-desktop');
    }
  }
}


export { initializeFormEvents };
